import "./InputRange.scss";
import { useRef } from "react";

export function InputRange({ className, ...rest }) {
	const ref = useRef();

	return (
		<input
			type="range"
			ref={ref}
			className={`${className} input-range`}
			{...rest}
		/>
	);
}
